import { DatePicker, DatePickerProps } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

import 'moment/locale/vi';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import enUS from 'antd/lib/date-picker/locale/en_US';
import 'moment/locale/vi';

import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar.svg';
import { ReactComponent as RightArrow } from 'app/assets/img/rightArr.svg';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import moment from 'moment';

interface MonthPickerComponentProps extends Omit<DatePickerProps, 'picker'> {}

const MonthPickerComponent = (
  props: MonthPickerComponentProps & {
    containerStyle?: React.CSSProperties;
    defaultValue?: moment.Moment | null;
    valueCalendar?: moment.Moment;
    onChangeCalendar?: (value: moment.Moment) => void;
  },
) => {
  const { containerStyle, valueCalendar, onChangeCalendar, defaultValue } =
    props;
  const { locale } = useGlobalFunction();
  const popupContainerRef = useRef<HTMLDivElement>(null);
  const [calendarValue, setCalendarValue] = useState(
    defaultValue || valueCalendar,
  );
  const monthToShow = useMemo(() => {
    if (!calendarValue) return 'MM/YYYY';
    const month =
      locale === 'vi'
        ? `Tháng ${calendarValue.month() + 1}`
        : calendarValue.locale('en_US').format('MMMM');

    return `${month}/${calendarValue.format('YYYY')}`;
  }, [locale, calendarValue]);

  useEffect(() => {
    setCalendarValue && setCalendarValue(valueCalendar);
  }, [valueCalendar]);

  return (
    <Container style={containerStyle}>
      {/* <MonthToShow>{monthToShow}</MonthToShow> */}
      <PopupContainer ref={popupContainerRef} />
      <CustomDatePicker
        value={calendarValue}
        format={() => monthToShow}
        onChange={value => {
          setCalendarValue(value!);
          onChangeCalendar && onChangeCalendar(value!);
        }}
        locale={locale === 'vi' ? viVN : enUS}
        picker="month"
        getPopupContainer={() => popupContainerRef.current!}
        monthCellRender={(date, datePickerLocale) => {
          return (
            <StyledMonth>
              {locale === 'vi'
                ? `${datePickerLocale.month} ${date.month() + 1}`
                : date.locale(locale).format('MMMM')}
            </StyledMonth>
          );
        }}
        superNextIcon={
          <ButtonControl style={{ marginRight: 8 }}>
            <RightArrow />
          </ButtonControl>
        }
        superPrevIcon={
          <ButtonControl style={{ transform: 'rotate(180deg)', marginLeft: 8 }}>
            <RightArrow />
          </ButtonControl>
        }
        popupStyle={{
          borderRadius: 16,
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
          overflow: 'hidden',
        }}
        allowClear={false}
        suffixIcon={<CalendarIcon width={16} height={16} />}
        inputReadOnly
        {...props}
      />
    </Container>
  );
};

export default MonthPickerComponent;

const Container = styled.div`
  position: relative;
  /* padding: 12px 14px;
  border: solid 1px #d9d9d9;
  border-radius: 10px; */
  .ant-picker-input:hover .ant-picker-clear {
    height: 16px;
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-picker-input > input:placeholder-shown {
    font-style: italic;
  }
  .ant-picker-month-panel {
    width: 284px;
    padding: 16px 8px;
    .ant-picker-header {
      border: none;
      .ant-picker-year-btn {
        font-weight: 600;
        font-size: 15px;
        color: #0e0e0f;
        font-family: 'Inter';
      }
    }
    .ant-picker-body {
      margin-top: 12px;
    }
    .ant-picker-content {
      height: 190px;
      .ant-picker-cell {
        padding: 10px 0;
        &.ant-picker-cell-selected {
          background: #e92127;
          border-radius: 10px;
          span {
            color: #ffffff;
          }
        }
      }
    }
  }
`;

const CustomDatePicker = styled(DatePicker)`
  &.ant-picker {
    /* padding-top: 12px;
    padding-bottom: 12px;
    width: 100%;
    background: transparent;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    border: none; */
    padding: 10.5px 10px;
    border: solid 1px #d9d9d9;
    border-radius: 10px;
    width: 160px; //dot not modify
    &.ant-picker-focused {
      box-shadow: none;
    }
    input {
      /* opacity: 0; */
      font-weight: 400;
      font-size: 14px;
      color: #45454a;
      cursor: pointer;
    }
  }
`;

const StyledMonth = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #45454a;
  cursor: pointer;
`;

const ButtonControl = styled.div`
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

const MonthToShow = styled.p`
  margin: 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  margin-right: 24px;
`;

const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
